import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import star from "../../assets/star.png";
import chart from "../../assets/chart.png";
import line from "../../assets/line.png";
import Chart from "../../Components/Chart";

const TokenAllocation = () => {
  return (
    <Box
      sx={{
        background: `url(${star}), #021B33`,
        backgroundSize: "100% 100%",
        height: "100%",
        backgroundRepeat: "no-repeat",
        paddingBottom: "2rem",
      }}
    >
      <Container>
        <Typography
          sx={{
            fontSize: { xs: "25px", md: "40px" },
            fontFamily: "Zen Dots",
            fontWeight: "400",
            textAlign: "center",
            pt: 10,
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          Token Allocation
        </Typography>
        <Typography
          sx={{
            fontSize: { md: "20px", xs: "15px" },
            fontWeight: "400",
            fontFamily: "Inter",
            color: "#D9D9D9",
            textAlign: "center",
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </Typography>
        <Typography
          sx={{
            fontSize: { md: "20px", xs: "15px" },
            fontWeight: "400",
            fontFamily: "Inter",
            color: "#D9D9D9",
            textAlign: "center",
          }}
        >
          Eget quam est, elit venenatis nulla.
        </Typography>

        <Box py={4}>
          <Grid container spacing={4}>
            <Grid md={6} xs={12} item>
              <Box mt={5}>
                <Chart />
              </Box>
            </Grid>
            <Grid md={6} xs={12} item>
              <Box mt={5}>
                {[1, 2, 3, 4, 5].map((item, i) => {
                  return (
                    <Box
                      key={i}
                      display="flex"
                      justifyContent="space-between"
                      p={2}
                      sx={{
                        background: "rgba(212, 114, 146, 0.2)",
                        borderBottom: "5px solid #5BF8FF",
                      }}
                      mt={3}
                    >
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          color: "#D9D9D9",
                          textAlign: "center",
                        }}
                      >
                        TEAM & ADVISOR
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          color: "#D9D9D9",
                          textAlign: "center",
                        }}
                      >
                        15,000,000,000
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default TokenAllocation;
